import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceSyncDevicePathParameters } from 'api/actions/remote-source-sync-device/remote-source-sync-device-path-parameters';
import { RemoteSourceSyncDeviceResponse } from 'api/actions/remote-source-sync-device/remote-source-sync-device-response';

type RemoteSourceSyncDeviceQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceSyncDevice action.
 */
export const remoteSourceSyncDeviceActionPath = new SweetPath<keyof RemoteSourceSyncDevicePathParameters>(
  '/api/remote-source/device/sync/{remoteSourceId}/{deviceRemoteId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceSyncDevice actions.
 */
export default function createRemoteSourceSyncDeviceAction(axios: AxiosInstance) {
  return function remoteSourceSyncDeviceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RemoteSourceSyncDevicePathParameters;
    query?: RemoteSourceSyncDeviceQueryParameters;
  }) {
    const path = remoteSourceSyncDeviceActionPath.insert(parameters);

    return axios.request<RemoteSourceSyncDeviceResponse, RemoteSourceSyncDeviceResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
